interface ICreatePopperAnchorProps {
  followCursor: boolean;
  x: number;
  y: number;
}
export const createPopperAnchor = ({
  followCursor,
  x,
  y
}: ICreatePopperAnchorProps) => {
  if (!followCursor) return {};

  return ({
    PopperProps: {
      anchorEl: {
        clientHeight: 0,
        clientWidth: 0,
        getBoundingClientRect: () => ({
          top: y,
          left: x,
          right: x,
          bottom: y,
          width: 0,
          height: 0,
        }),
      },
    },
  });
}

export const initializeMouseMoveListener = (
  followCursor: boolean,
  positionRef: React.MutableRefObject<{ x: number; y: number }>,
  setPosition: React.Dispatch<React.SetStateAction<{ x: number; y: number }>>,
  animationFrame: React.MutableRefObject<number | null>
) => {
  if (!followCursor) return;

  const handleMouseMove = (e: MouseEvent) => {
    positionRef.current = { x: e.pageX, y: e.pageY };

    if (animationFrame.current === null) {
      animationFrame.current = requestAnimationFrame(() => {
        setPosition(positionRef.current);
        animationFrame.current = null;
      });
    }
  };

  window.addEventListener('mousemove', handleMouseMove);

  return () => {
    window.removeEventListener('mousemove', handleMouseMove);
    if (animationFrame.current) {
      cancelAnimationFrame(animationFrame.current);
    }
  };
};
